var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 98,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 1209,
    width: 130,
    height: 98
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1537 -1209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1585.5 1209C1599.03 1209 1610 1219.97 1610 1233.5 1610 1247.03 1599.03 1258 1585.5 1258 1571.97 1258 1561 1247.03 1561 1233.5 1561 1219.97 1571.97 1209 1585.5 1209Z",
    fill: "#B1B1B1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.1 1217 1662.9 1217C1665.16 1217 1667 1218.79 1667 1221 1667 1223.21 1665.16 1225 1662.9 1225L1630.1 1225C1627.84 1225 1626 1223.21 1626 1221 1626 1218.79 1627.84 1217 1630.1 1217Z",
    fill: "#51C0A3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.1 1242 1662.9 1242C1665.16 1242 1667 1243.79 1667 1246 1667 1248.21 1665.16 1250 1662.9 1250L1630.1 1250C1627.84 1250 1626 1248.21 1626 1246 1626 1243.79 1627.84 1242 1630.1 1242Z",
    fill: "#51C0A3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.5 1266C1625.92 1266 1634 1290.6 1634 1298.8 1634 1307 1625.92 1307 1625.92 1307L1545.08 1307C1545.08 1307 1537 1307 1537 1298.8 1537 1290.6 1545.08 1266 1585.5 1266Z",
    fill: "#B1B1B1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.17 1266 1662.83 1266C1665.13 1266 1667 1267.79 1667 1270 1667 1272.21 1665.13 1274 1662.83 1274L1646.17 1274C1643.87 1274 1642 1272.21 1642 1270 1642 1267.79 1643.87 1266 1646.17 1266Z",
    fill: "#51C0A3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.17 1290 1662.83 1290C1665.13 1290 1667 1291.79 1667 1294 1667 1296.21 1665.13 1298 1662.83 1298L1646.17 1298C1643.87 1298 1642 1296.21 1642 1294 1642 1291.79 1643.87 1290 1646.17 1290Z",
    fill: "#51C0A3",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.6dced76ba075e210456ed848aae141be.svg";
export { ForwardRef as ReactComponent };